var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivestock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.42,
    height: 19,
    viewBox: "0 0 14.42 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "steak",
    transform: "translate(-15.83 -4.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60941",
    "data-name": "Group 60941",
    transform: "translate(16.675 5.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87769",
    "data-name": "Path 87769",
    d: "M20.653,15.9c-.093.04-.255.082-.39.141a.242.242,0,0,1-.333-.143,3.38,3.38,0,0,1-.093-.943,6.419,6.419,0,0,1,1.585-4.393,5.029,5.029,0,0,1,4.442-1.545,6.484,6.484,0,0,1,1.262.342c.177.065.357.122.424.314a1.1,1.1,0,0,1-.063.625A2.409,2.409,0,0,1,26.1,11.827a3.386,3.386,0,0,1-.85.283.923.923,0,0,1-.331-.015,2.01,2.01,0,0,0-1.713.338,1.738,1.738,0,0,0-.707,1.093c-.072.435.027.878-.232,1.268a2.671,2.671,0,0,1-.947.77C21.1,15.687,20.879,15.8,20.653,15.9Z",
    transform: "translate(-19.836 -8.957)",
    fill: "#015ca3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60942",
    "data-name": "Group 60942",
    transform: "translate(17.43 12.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87770",
    "data-name": "Path 87770",
    d: "M29.952,41.27c.9,1.34.751,3.053.684,4.585-.04.888-.095,1.779-.215,2.659a2.516,2.516,0,0,1-.658,1.732,1.5,1.5,0,0,1-.684.253,6.087,6.087,0,0,1-3.321-.409,3.846,3.846,0,0,1-1.363-.941,3.548,3.548,0,0,1-.7-1.5,3.236,3.236,0,0,1,.057-1.91,4.951,4.951,0,0,0,.437-1.849A4.632,4.632,0,0,0,23.837,42c-.057-.137-.12-.274-.19-.407a1.952,1.952,0,0,1-.228-.422c-.051-.219.141-.407.27-.561a2.168,2.168,0,0,1,1.448-.836,7.88,7.88,0,0,1,1.946.213,7.844,7.844,0,0,1,1.884.422,2.372,2.372,0,0,1,.985.861Z",
    transform: "translate(-23.411 -39.762)",
    fill: "#015ca3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60943",
    "data-name": "Group 60943",
    transform: "translate(23.548 7.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87771",
    "data-name": "Path 87771",
    d: "M57.418,18.524a7.743,7.743,0,0,1,.836,3.748,10.962,10.962,0,0,1-.781,4.216q-.2.491-.441.96A10.653,10.653,0,0,1,54.57,30.6c-.175.15-.447.386-.625.095a1.007,1.007,0,0,1-.1-.325,5.306,5.306,0,0,1-.076-1.051c0-.9.089-1.8.175-2.695a11.15,11.15,0,0,0,.146-1.754,8.278,8.278,0,0,0-.867-2.988c-.169-.365-.363-.722-.523-1.089a3.009,3.009,0,0,1-.173-2.112,4.255,4.255,0,0,1,.81-1.319,3.034,3.034,0,0,1,1.078-.971c.274-.131.5-.245.783-.061a9.178,9.178,0,0,1,.916.7,5.977,5.977,0,0,1,1.306,1.5Z",
    transform: "translate(-52.406 -16.236)",
    fill: "#015ca3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60944",
    "data-name": "Group 60944",
    transform: "translate(15.83 4.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87772",
    "data-name": "Path 87772",
    d: "M29.761,10.267a7.432,7.432,0,0,0-3.273-3.729,8.249,8.249,0,0,0-5.2-1.526,5.871,5.871,0,0,0-4.176,2.5,7.534,7.534,0,0,0-1.258,4.864,2.442,2.442,0,0,0,.39,1.209,7.389,7.389,0,0,1,.764,1.137,3.845,3.845,0,0,1,.2,2.665,9.01,9.01,0,0,0-.407,1.306,4.726,4.726,0,0,0,.036,1.473,4.365,4.365,0,0,0,1.007,2.167,5.99,5.99,0,0,0,4.322,1.644,5.844,5.844,0,0,0,1.393-.162,7.876,7.876,0,0,0,4.161-3,11.833,11.833,0,0,0,2.294-5.005,11.062,11.062,0,0,0-.255-5.548Zm-4.237,12.15a5.817,5.817,0,0,1-4.965.943,5.5,5.5,0,0,1-1.726-.753,3.463,3.463,0,0,1-1.405-1.857,3.913,3.913,0,0,1-.07-2.572,4.63,4.63,0,0,0,.369-2.541,4.228,4.228,0,0,0-.392-1.209,7.852,7.852,0,0,0-.717-1.047,3.676,3.676,0,0,1-.317-2.473,6.617,6.617,0,0,1,1.946-4.071,5.449,5.449,0,0,1,4.488-1.382,8.459,8.459,0,0,1,2.52.867,11.494,11.494,0,0,1,2.178,1.42,6.378,6.378,0,0,1,1.593,1.865,7.256,7.256,0,0,1,.7,2.526,11.8,11.8,0,0,1,.089,1.338,11.29,11.29,0,0,1-4.294,8.945Z",
    transform: "translate(-15.83 -4.978)",
    fill: "#015ca3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60945",
    "data-name": "Group 60945",
    transform: "translate(20.031 9.37)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4796",
    "data-name": "Ellipse 4796",
    cx: 1.376,
    cy: 1.376,
    r: 1.376,
    transform: "translate(0 0)",
    fill: "#015ca3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivestock);
export default __webpack_public_path__ + "static/media/livestock.9073a3b5d16e49d83a28cb6e9845f027.svg";
export { ForwardRef as ReactComponent };